import { useApp } from 'AppContext'
import { DPGeneral } from 'types/DPTypes'

export const useLinks = () => {
  return useApp().general.links
}

export type LinkKey = keyof DPGeneral['links']